module.exports = __webpack_public_path__ + "static/media/target_circle.55e85c69.png";